namespace GeniuzPOS.Product {
    export interface SkuHdForm {
        SkuCode: Serenity.StringEditor;
        ActiveFg: Serenity.BooleanEditor;
        SkuDesc: Serenity.StringEditor;
        SkuEnDesc: Serenity.StringEditor;
        ActivePurFg: Serenity.BooleanEditor;
        ActiveSellFg: Serenity.BooleanEditor;
        ActiveRepFg: Serenity.BooleanEditor;
        NonAllowtoDiscountFg: Serenity.BooleanEditor;
        BrandCode: Serenity.LookupEditor;
        BrandTypeCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        ConceptCode: Serenity.LookupEditor;
        ArticleSeasonCode: Serenity.LookupEditor;
        ProductCpComponent: Serenity.StringEditor;
        ProductCpDesc1: Serenity.StringEditor;
        ProductCpDesc2: Serenity.StringEditor;
        ProductCpHowToUse: Serenity.StringEditor;
        ProductCpWarning: Serenity.StringEditor;
        SupplierId: Serenity.LookupEditor;
        CusImportOrLocal: Serenity.LookupEditor;
        ConsignFg: Serenity.BooleanEditor;
        ConsignGp: Serenity.DecimalEditor;
        CusProductTypeNbp: Serenity.LookupEditor;
        VatType: Serenity.LookupEditor;
        VatCode: Serenity.LookupEditor;
        PurVatType: Serenity.LookupEditor;
        PurVatCode: Serenity.LookupEditor;
        CusProductSalesBeforeFlag: Serenity.LookupEditor;
        CusProductSalesBeforeReferFlag: Serenity.LookupEditor;
        MarketDate: Serenity.DateEditor;
        ExpDate: Serenity.DateEditor;
        CusProductSalesBeforeRefer: Serenity.StringEditor;
        ProdImageLink: Serenity.MultipleImageUploadEditor;
        StockFg: Serenity.BooleanEditor;
        SetItemFg: Serenity.BooleanEditor;
        PurLeadTime: Serenity.DecimalEditor;
        StkUnit: Serenity.LookupEditor;
        MinStockQty: Serenity.DecimalEditor;
        MaxStockQty: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        PurUnit: Serenity.LookupEditor;
        MinOrderQty: Serenity.DecimalEditor;
        MaxOrderQty: Serenity.DecimalEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        LastPurPrice: Serenity.DecimalEditor;
        QtyOnhand: Serenity.DecimalEditor;
        StockCostValue: Serenity.DecimalEditor;
        LastStockCostUnit: Serenity.DecimalEditor;
        SupplItemCode: Serenity.StringEditor;
        PluDtList: PluDtEditor;
    }

    export class SkuHdForm extends Serenity.PrefixedContext {
        static formKey = 'Product.SkuHd';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SkuHdForm.init)  {
                SkuHdForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;
                var w5 = s.MultipleImageUploadEditor;
                var w6 = PluDtEditor;

                Q.initFormType(SkuHdForm, [
                    'SkuCode', w0,
                    'ActiveFg', w1,
                    'SkuDesc', w0,
                    'SkuEnDesc', w0,
                    'ActivePurFg', w1,
                    'ActiveSellFg', w1,
                    'ActiveRepFg', w1,
                    'NonAllowtoDiscountFg', w1,
                    'BrandCode', w2,
                    'BrandTypeCode', w2,
                    'CatCode', w2,
                    'SubCat1Code', w2,
                    'SubCat2Code', w2,
                    'StyleId', w2,
                    'ColorId', w2,
                    'SizeId', w2,
                    'TasteId', w2,
                    'MatTypeId', w2,
                    'ConceptCode', w2,
                    'ArticleSeasonCode', w2,
                    'ProductCpComponent', w0,
                    'ProductCpDesc1', w0,
                    'ProductCpDesc2', w0,
                    'ProductCpHowToUse', w0,
                    'ProductCpWarning', w0,
                    'SupplierId', w2,
                    'CusImportOrLocal', w2,
                    'ConsignFg', w1,
                    'ConsignGp', w3,
                    'CusProductTypeNbp', w2,
                    'VatType', w2,
                    'VatCode', w2,
                    'PurVatType', w2,
                    'PurVatCode', w2,
                    'CusProductSalesBeforeFlag', w2,
                    'CusProductSalesBeforeReferFlag', w2,
                    'MarketDate', w4,
                    'ExpDate', w4,
                    'CusProductSalesBeforeRefer', w0,
                    'ProdImageLink', w5,
                    'StockFg', w1,
                    'SetItemFg', w1,
                    'PurLeadTime', w3,
                    'StkUnit', w2,
                    'MinStockQty', w3,
                    'MaxStockQty', w3,
                    'PurUnitRatio', w3,
                    'PurUnit', w2,
                    'MinOrderQty', w3,
                    'MaxOrderQty', w3,
                    'PurUnitPrice', w3,
                    'LastPurPrice', w3,
                    'QtyOnhand', w3,
                    'StockCostValue', w3,
                    'LastStockCostUnit', w3,
                    'SupplItemCode', w0,
                    'PluDtList', w6
                ]);
            }
        }
    }
}
